<template>
    <div
        v-epi-edit="pagePropertyName"
        v-if="images"
    >
        <Slider :items="images" />
    </div>
</template>

<script>
import Slider from '@/Scripts/components/organisms/Slider/slider.vue';

export default {
    props: ['model', 'pagePropertyName'],
    components: {
        Slider
    },
    data() {
        return {
            images: (this.model.images && this.model.images.length > 0 ? this.model.images : null)
        };
    }
};
</script>
